import React, { useEffect, useState, useRef } from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setIsVisible(true);
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} className="py-10 bg-gradient-to-b from-blue-600 to-blue-700 text-white" data-id="element-30">
      <div className="max-w-xl mx-auto px-4" data-id="element-31">
        <div className={`flex items-center gap-5 bg-blue-500/40 rounded-2xl p-6 border border-blue-400/50 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} data-id="element-32">
          <div className="bg-orange-500 rounded-full p-3 flex-shrink-0" data-id="element-33">
            <ShieldCheck className="w-8 h-8 text-white" strokeWidth={2.5} data-id="element-34" />
          </div>
          <div data-id="element-35">
            <p className="font-black text-lg mb-1" data-id="element-36">
              Garantía{' '}
              <span className="text-orange-400" data-id="element-37">7 días sin riesgo</span>
            </p>
            <p className="text-blue-100 text-sm leading-relaxed" data-id="element-38">
              Si no te convence, te devolvemos el{' '}
              <span className="font-bold text-white" data-id="element-39">100% de tu dinero</span>.
              Sin preguntas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}